// The password rule the server enforces (backend/auth.py password_problem), checked as the person types so the
// form can show what is still missing. The server stays the judge: it also refuses common passwords and ones
// containing the person's name.
export const PASSWORD_MIN = 10;

export const PASSWORD_RULES = [
  { id: "length", label: `At least ${PASSWORD_MIN} characters`, test: (p) => (p || "").length >= PASSWORD_MIN },
  { id: "letter", label: "A letter", test: (p) => /[A-Za-z]/.test(p || "") },
  { id: "number", label: "A number", test: (p) => /\d/.test(p || "") },
];

/** Why this password would be refused, or "" when it meets the rule. */
export function passwordProblem(p) {
  if ((p || "").length < PASSWORD_MIN) return `Use at least ${PASSWORD_MIN} characters.`;
  if ((p || "").length > 64) return "Use at most 64 characters.";
  if (!/[A-Za-z]/.test(p) || !/\d/.test(p)) return "Use both letters and numbers.";
  return "";
}
